module.exports = __webpack_public_path__ + "img/t4g.5be9df7c.svg";